export const GET_RULE_LIST_REQUEST = 'GET_RULE_LIST_REQUEST';
export const GET_RULE_LIST_SUCCESS = 'GET_RULE_LIST_SUCCESS';
export const GET_RULE_LIST_ERROR = 'GET_RULE_LIST_ERROR';
export const ADD_RULE_REQUEST = 'ADD_RULE_REQUEST';
export const ADD_RULE_SUCCESS = 'ADD_RULE_SUCCESS';
export const ADD_RULE_ERROR = 'ADD_RULE_ERROR';
export const GET_RULE_REQUEST = 'GET_RULE_REQUEST';
export const GET_RULE_SUCCESS = 'GET_RULE_SUCCESS';
export const GET_RULE_ERROR = 'GET_RULE_ERROR';
export const UPDATE_RULE_REQUEST = 'UPDATE_RULE_REQUEST';
export const UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';
export const UPDATE_RULE_ERROR = 'UPDATE_RULE_ERROR';
export const PARTIAL_UPDATE_RULE_REQUEST = 'PARTIAL_UPDATE_RULE_REQUEST';
export const PARTIAL_UPDATE_RULE_SUCCESS = 'PARTIAL_UPDATE_RULE_SUCCESS';
export const PARTIAL_UPDATE_RULE_ERROR = 'PARTIAL_UPDATE_RULE_ERROR';
export const DELETE_RULE_REQUEST = 'DELETE_RULE_REQUEST';
export const DELETE_RULE_SUCCESS = 'DELETE_RULE_SUCCESS';
export const DELETE_RULE_ERROR = 'DELETE_RULE_ERROR';
export const UPDATE_RULE_LIST_OPTIONS = 'UPDATE_RULE_LIST_OPTIONS';
export const SELECT_RULE = 'SELECT_RULE';
export const DESELECT_RULE = 'DESELECT_RULE';
export const REORDER_RULE_REQUEST = 'REORDER_RULE_REQUEST';
export const REORDER_RULE_SUCCESS = 'REORDER_RULE_SUCCESS';
export const REORDER_RULE_ERROR = 'REORDER_RULE_ERROR';
export const MOVE_RULE_TO_GROUP = 'MOVE_RULE_TO_GROUP';
export const PARTIAL_EXPORT_RULE_REQUEST = 'PARTIAL_EXPORT_RULE_REQUEST';
export const PARTIAL_EXPORT_RULE_COMPLETE = 'PARTIAL_EXPORT_RULE_COMPLETE';
export const PARTIAL_EXPORT_RULE_CANCEL = 'PARTIAL_EXPORT_RULE_CANCEL';

export const PARTIAL_IMPORT_RULE_REQUEST = 'PARTIAL_IMPORT_RULE_REQUEST';
export const PARTIAL_IMPORT_RULE_COMPLETE = 'PARTIAL_IMPORT_RULE_COMPLETE';
export const PARTIAL_IMPORT_RULE_CANCEL = 'PARTIAL_IMPORT_RULE_CANCEL';
